import Keycloak from "keycloak-js";
import { KEYCLOAK } from "../../constants/keycloakConstants";
import { isRoutePublic } from "../../helpers/publicRoutes";

const keycloakConfig = {
  url: KEYCLOAK.URL,
  realm: KEYCLOAK.REALM,
  clientId: KEYCLOAK.CLIENT_ID,
};

/**
 * Registers update interval of keycloak token.
 */
export const registerUpdateInterval = (keycloak: Keycloak, updateInterval: number): void => {
  const logoutParams = {
    redirectUri: `${window.location.origin}/p/logout`,
  };

  setInterval(() => {
    keycloak.updateToken(KEYCLOAK.TOKEN_EXPIRATION_TIME).catch(() => {
      keycloak.logout(logoutParams);
    });
  }, updateInterval);
};

/**
 * Initilizes keycloak and redirects to the login page if users is not logged in
 */
export const initKeycloak = async (
  updateInterval: number = KEYCLOAK.DEFAULT_UPDATE_INTERVAL
): Promise<Keycloak | null> => {
  if (isRoutePublic()) {
    return;
  }

  const keycloak = new Keycloak(keycloakConfig);

  const auth = await keycloak.init({
    onLoad: KEYCLOAK.ON_LOAD,
  });

  const params = new URLSearchParams(location.search);
  const idp = params.get("idp") || "default";

  if (!auth) {
    await keycloak.login({
      idpHint: idp,
    });

    return null;
  } else {
    params.delete("idp");
    const query = params.toString();
    let path = window.location.pathname;

    if (query) {
      path += `?${params.toString()}`;
    }
    window.history.pushState({}, document.title, path);
  }

  registerUpdateInterval(keycloak, updateInterval);

  return keycloak;
};
